import type { RootState } from "../store";

export const selectMarketplace = (state: RootState) => state.marketplace;
export const selectProducts = (state: RootState) => state.marketplace.products;
export const selectOffers = (state: RootState) => state.marketplace.offers;
export const selectBestSellers = (state: RootState) => state.marketplace.bestSellers;
export const selectMarketplaceError = (state: RootState) => state.marketplace.error;
